/**
 * WordPress dependencies
 */
export * from '@wordpress/icons';
